import React, { createContext, useContext, useState } from "react";
import {
  getGeneralDesignApprovalsByApprover,
  getPaymentsProgressApprovalsByApprover,
} from "../api/paymentsProgressApi";

const PendingPaymentsProgressApprovalsContext = createContext();

const isPendingStatus = (status) => {
  const s = String(status || "").toLowerCase();
  return !s || s === "in_processing" || s === "pending" || s === "на рассмотрении";
};

const normalizeApprovals = (approvals) =>
  (Array.isArray(approvals) ? approvals : []).map((entry) =>
    entry?.approval != null ? entry.approval : entry
  );

const countPendingForUser = (approvals, userId) =>
  normalizeApprovals(approvals).filter((approval) => {
    const myApprover = approval?.approvers?.find(
      (approver) =>
        Number(approver?.user?.id) === Number(userId) ||
        Number(approver?.user_id) === Number(userId)
    );
    return myApprover && isPendingStatus(myApprover.status);
  }).length;

export function PendingPaymentsProgressApprovalsProvider({ children }) {
  const [pendingPaymentsProgressApprovalsCount, setPendingPaymentsProgressApprovalsCount] =
    useState(0);

  const updatePendingPaymentsProgressApprovalsCount = async (userData) => {
    if (!userData?.id) {
      setPendingPaymentsProgressApprovalsCount(0);
      return;
    }

    try {
      const [paymentsApprovals, gpApprovals] = await Promise.all([
        getPaymentsProgressApprovalsByApprover(),
        getGeneralDesignApprovalsByApprover(),
      ]);
      const pendingPaymentsCount = countPendingForUser(paymentsApprovals, userData.id);
      const pendingGpCount = countPendingForUser(gpApprovals, userData.id);

      setPendingPaymentsProgressApprovalsCount(
        pendingPaymentsCount + pendingGpCount
      );
    } catch (error) {
      console.debug("Нет согласований выплат (ЭП/ГП) в ожидании");
      setPendingPaymentsProgressApprovalsCount(0);
    }
  };

  return (
    <PendingPaymentsProgressApprovalsContext.Provider
      value={{
        pendingPaymentsProgressApprovalsCount,
        updatePendingPaymentsProgressApprovalsCount,
      }}
    >
      {children}
    </PendingPaymentsProgressApprovalsContext.Provider>
  );
}

export const usePendingPaymentsProgressApprovals = () =>
  useContext(PendingPaymentsProgressApprovalsContext);
